// src/services/authService.js
import axios from 'axios';
import { toFormData } from './utils'; // Utility function

const authService = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
});


export const getStarted = () => {
    return authService.get('/auth/get-started');
};

export const login = (credentials) => {
    const formData = toFormData(credentials);
    return authService.post('/auth/login', formData);
};

export const register = (userData) => {
    const formData = toFormData(userData);
    return authService.post('/auth/register', formData);
};

export const forgotPassword = (data) => {
    const formData = toFormData(data);
    return authService.post('/auth/forgot-password', formData);
};

export const verifyEmail = (formData) => {
    return authService.get('/auth/verify-email?token='+formData.token+'&old_email='+formData.old_email+'&new_email='+formData.new_email);
};

export const resetPassword = (data) => {
    const formData = toFormData(data);
    return authService.post('/auth/reset-password', formData);
};

export default authService;
